import { NavLink, Outlet } from "react-router-dom";

const links = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/health", label: "Health" },
  { to: "/shopify", label: "Shopify Connection" },
  { to: "/shopify-schema", label: "Shopify Schema" },
  { to: "/database", label: "Database Status" },
  { to: "/sandlot", label: "Sandlot Explorer" },
  { to: "/inspector", label: "Customer Inspector" },
  { to: "/match-review", label: "Match Review" },
  { to: "/preview", label: "Migration Preview" },
  { to: "/testing", label: "Migration Testing" },
  { to: "/club-migration", label: "Metaobject Migration" },
  { to: "/jobs", label: "Migration Jobs" },
  { to: "/matches", label: "Matches" },
];

export function Layout() {
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">GORUCK Migration</div>
        <div className="brand-sub">Internal Migration Platform</div>
        <nav className="nav">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}>
              {l.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
